import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import './BiographyPage.css';
import './OurHistoryPage.css';

const OurHistoryPage = ({ onBack, onNavigate }) => {
  const navigate = (target) => {
    if (onNavigate) onNavigate(target);
    else if (onBack) onBack();
  };

  return (
    <div className="oh-page">

      {/* Navbar */}
      <nav className="bio-navbar">
        <div className="bio-navbar-logo">
          <img src="/Sndp/logo.png" alt="Pravasi SNDP Yogam Logo" />
        </div>
        <div className="bio-navbar-links">
          <div className="bio-nav-menu">
            <a href="#home" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('home'); }}>Home</a>
            <div className="bio-nav-about-wrapper">
              <span className="bio-nav-link bio-nav-dropdown">
                About <FiChevronDown size={14} />
              </span>
              <div className="bio-nav-about-dropdown">
                <button onClick={() => navigate('ourhistory')}>Our History</button>
                <button onClick={() => navigate('leadership')}>Leadership</button>
              </div>
            </div>
            <a href="#gallery" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a>
            <a href="#news" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('news'); }}>News &amp; Articles</a>
            <a href="#eventcalendar" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('eventcalendar'); }}>Event Calendar</a>
            <a href="#constitution" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('constitution'); }}>Constitution</a>
            <a href="#membership" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('membership'); }}>Membership</a>
            <a href="#contact" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('contact'); }}>Contact Us</a>
          </div>
          <a href="#donate" className="bio-donate-btn">Donation</a>
        </div>
      </nav>

      {/* Section 1: Heading + intro text + image */}
      <div className="oh-section-1">
        <div className="oh-section-1-left">
          <h1 className="oh-page-heading">Our History</h1>
          <p className="oh-intro-text">
            We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru,
            a revered saint and social reformer from Kerala, India (1854-1928).
            The term "Pravasi", derived from Malayalam, beautifully encapsulates the
            essence of individuals who, driven by ambition and opportunity, leave their
            native land to reside and work in foreign territories. In this context, the
            "Pravasi SNDP Yogam" stands as a beacon of hope and support, dedicated to
            the well-being of these expatriates. This organisation fervently champions
            initiatives that not only empower these individuals in their new endeavours
            but also foster an enduring connection to their cultural roots. With a
            commitment to nurturing a sense of belonging, the Pravasi SNDP Yogam ensures
            that members can navigate their new worlds without losing the rich heritage
            and traditions that define them.
          </p>
        </div>
        <div className="oh-section-1-right">
          <img src={`${process.env.PUBLIC_URL}/Sndp/image-2.png`} alt="Sree Narayana Guru meditating" />
        </div>
      </div>

      {/* Section 2: Small image + long history text */}
      <div className="oh-section-2">
        <div className="oh-section-2-img">
          <img src="/Sndp/images.jpeg" alt="SNDP History" />
        </div>
        <p className="oh-section-2-text">
          In June 2014, we established the SNDP YOGAM (Sree Narayana Dharma Paripalana
          Yogam) UK 6170 in Wembley, London, under the umbrella of the SNDP Yogam Kerala,
          bringing together members from across the UK. While our community has grown, many
          members have found it challenging to engage in activities due to geographical
          distance. To enhance participation and support for our members in the southwest
          regions, we formed the PRAVASI SNDP YOGAM UK in February 2022, with a base in
          Bristol. Our network now includes units in various locations throughout the
          southwest and east, including Swindon, Devizes, Bridgwater, Taunton, Barnstaple,
          Swansea, Southampton, and Eastham. We gather monthly for prayers and meetings,
          fostering a strong sense of community among our devotees. The mission of Pravasi
          SNDP Yogam UK is to promote the teachings and principles of Sree Narayana Guru,
          foster social harmony, and support the spiritual and cultural development of the
          community. To educate our members and children on the Sree Narayana Guru's
          teachings, we arrange various public functions like Sree Narayana Guru Jayanthi
          and Guru Samadhi, symbolic pilgrimages, and seminars. The organisation aims to
          uphold Guru's ideals of equality, education, and social reform, while also
          encouraging the welfare and unity of the Malayali diaspora in the United Kingdom.
          We also actively remain in the cultural and philanthropic activities.
        </p>
      </div>

      {/* Section 3: Yellow background — text + image */}
      <div className="oh-section-3">
        <div className="oh-section-3-inner">
          <p className="oh-section-3-text">
            The Yogam now caters to diversified goals and empowers the weak and the needy
            to face socio-economic challenges and the realities of time. However, we
            currently face challenges in terms of space (GURU MANDIRAM) for worship and
            paying homage to Guru and conducting religious rituals, celebrating religious
            events and family gatherings. The sole Hindu temple in Bristol does not fully
            accommodate our rituals and communal activities. Recognising our status as a
            minority group, we see an opportunity to engage with our local council to
            discuss these challenges and seek their support and guidance in finding a
            suitable venue for our needs. We look forward to collaborating with community
            leaders to enhance our collective experience and strengthen our community ties.
          </p>
          <div className="oh-section-3-img">
            <img src="/Sndp/sivagiri-mutt-varkala-kerala-1-attr-hero.jpg" alt="Sivagiri Mutt" />
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bio-footer">
        <div className="bio-footer-main">
          <div className="bio-footer-brand">
            <div className="bio-footer-logo-row">
              <img src="/Sndp/logo.png" alt="Logo" className="bio-footer-logo-img" />
              <div className="bio-footer-brand-info">
                <h3 className="bio-footer-brand-name">Pravasi SNDP Yogam, UK Bristol</h3>
                <p className="bio-footer-brand-desc">
                  We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru,
                  a revered saint and social reformer from Kerala, India (1854-1928).
                </p>
                <div className="bio-footer-socials">
                  <a href="#facebook" aria-label="Facebook"><FiFacebook size={20} color="#FFC501" /></a>
                  <a href="#twitter" aria-label="Twitter"><FiTwitter size={20} color="#FFC501" /></a>
                  <a href="#instagram" aria-label="Instagram"><FiInstagram size={20} color="#FFC501" /></a>
                  <a href="#youtube" aria-label="YouTube"><FiYoutube size={28} color="#FFC501" /></a>
                </div>
              </div>
            </div>
          </div>

          <div className="bio-footer-contact">
            <h4 className="bio-footer-column-title">Contact Us</h4>
            <div className="bio-footer-contact-list">
              <div className="bio-footer-contact-item">
                <FiMapPin size={20} color="#FFC501" />
                <span>Almondsbury Creative 10 Gloucester Road, Bristol</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiPhone size={20} color="#FFC501" />
                <span>+91 84524145547</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiMail size={20} color="#FFC501" />
                <span>sndpyogamuk@gmail.com</span>
              </div>
            </div>
          </div>

          <div className="bio-footer-links">
            <h4 className="bio-footer-column-title">Quick Links</h4>
            <ul className="bio-footer-nav">
              <li><a href="#home" onClick={onBack}>Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#history">History</a></li>
              <li><a href="#organization">Organization</a></li>
              <li><a href="#sree-narayana-guru">Sree Narayana Guru</a></li>
              <li><a href="#articles">Articles</a></li>
              <li><a href="#gallery">Gallery</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="bio-footer-newsletter">
            <h4 className="bio-footer-column-title">Newsletter</h4>
            <p className="bio-newsletter-desc">Subscribe to our Newsletter</p>
            <div className="bio-newsletter-form">
              <input type="email" placeholder="Enter your email" />
              <button type="button">Subscribe</button>
            </div>
          </div>
        </div>

        <div className="bio-footer-bottom">
          <span>© 2025 Pravasi SNDP Yogam. All rights reserved.</span>
          <div className="bio-footer-bottom-links">
            <a href="#terms">Terms of Use</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default OurHistoryPage;
